<template>
    <div class="item">
        <div class="title">温室气象信息</div>
        <div class="value">
          <div class="option" v-for="(item,index) in list" :key="index">
            <div class="left">
              <img src="../../assets/manure/wenshi.png" alt="">
            </div>
            <div class="right">
              <p>{{ item.name }}</p>
              <p>{{ item.value }}{{ item.unit }}</p>
            </div>
          </div>
        </div>
    </div>
  </template>
  
  <script>
import { getQX_modelInfo } from '../../api/api'
  export default {
    data () {
      return {
        // 查询参数
        query:{
          deviceId:"19221015606",  //温室设备ID
          modelId:"21",   //模块ID
          zoneId:"0",    //区域序号
        },
        // 数据
        list:[
          {name:"空气温度", value:"21.3", unit:"℃"},
          {name:"空气湿度", value:"80.9", unit:"%RH"},
          {name:"光照强度", value:"1002.9", unit:"hpa"},
          {name:"风向", value:"153", unit:"°"},
          {name:"风速", value:"2.9", unit:"m/s"},
          {name:"降雨状态", value:"0.0", unit:""}, 
        ]
      }
    },
    created () { 
  
    },
    mounted () { 
      this.getData()
    },
    methods: {
      // 获取数据
      async getData(){
        let res = await getQX_modelInfo({
          ...this.query
        })
        console.log(res,"温室气象信息");
        if(res.code == 200){
          let data = res.data.Status
          this.list.forEach(item => {
            if(item.name == "空气温度"){
              item.value = data[0]
            }
            if(item.name == "空气湿度"){
              item.value = data[1]
            }
            if(item.name == "光照强度"){
              item.value = data[2]
            }
            if(item.name == "风向"){
              item.value = data[4]
            }
            if(item.name == "风速"){
              item.value = data[3]
            }
            if(item.name == "降雨状态"){
              item.value = data[5]=="0"?"无":"有"
            }
          })
        }

      },
    }
    
  }
  </script>

  <style lang="scss" scoped>
  .item{
    padding: 15px 6px 6px 15px;
    background-color: rgba(0, 0, 0, 0.5);
    font-family: SourceHanSansSC-regular;
    width: 500px;
    // height: 330px;
    // overflow-y: auto;
    .title{
        font-size: 20px;
        font-weight: bold;
        line-height: 29px;
        margin-bottom: 12px;
    }
    .value{
        display: flex;
        flex-wrap: wrap;;
        .option{
          width: 32%;
          margin-bottom: 18px;
          display: flex;
          align-items: center;
          .left{
            margin-right: 8px;
            img{
              width: 48px;
              height: 48px;
            }
          }
          .right{
            p{
              font-size: 16px;
              line-height: 17px;
            }
          }
        }
        
    }
  }
  
  
  </style>
  